
export default {
  props: {
    footerData: {
      type: Object,
      required: true,
    },
  },
}
